import React, { Component } from 'react';
import { object, bool, string, shape, number, array } from 'prop-types';
import classNames from 'classnames';
import { Tooltip } from '@fiverr-private/fit';
import { I18n } from '@fiverr-private/fiverr_context';
import { MP_CLICKED_NAVBAR } from '../../utils/mixPanelEvents';
import { BQ_CLICKED_TOPNAV } from '../../utils/bigQueryEvents';
import { isLoggedInUser } from '../../utils/isLoggedInUser';
import { GIG_NAV_MENU } from '../../utils/events';
import { RESTRICTED } from '../../utils/constants/userStatuses';
import UGCTranslateButton from '../UGCTranslateButton';
import SocialSharing from '../shared/SocialSharing';
import SafePureComponent from '../shared/SafePureComponent';
import CollectWrapper from './CollectWrapper';
import EditGig from './EditGig';
import ReportBtn from './ReportGig/ReportBtn';
import './style.scss';

class TopNav extends Component {

    constructor() {
        super();

        this.onNavClick = this.onNavClick.bind(this);
    }

    onNavClick(e, section) {
        const { biEvents } = this.context;

        e.preventDefault();
        this.props.scrollToSection(section);

        const mixPanelParams = {
            clickedSection: e.target.text,
            displayedSections: this.getValidatedSections().map(({ sectionKey }) => sectionKey)
        };
        biEvents.sendMixPanelEvent({ eventName: MP_CLICKED_NAVBAR, params: mixPanelParams });

        const bigQueryParams = { sectionKey: section.sectionKey };
        biEvents.sendBigQueryEvent({ eventName: BQ_CLICKED_TOPNAV, params: bigQueryParams });
    }

    getValidatedSections() {
        const { pageSectionsList } = this.props;

        return pageSectionsList.filter((section) => section.validated);
    }

    shouldRenderReportBtn() {
        const isLoggedIn = isLoggedInUser();
        const { currentUser } = this.context;
        const isRestricted = currentUser && currentUser.status === RESTRICTED;
        const { isPageOwner } = this.props;

        return isLoggedIn && !isPageOwner && !isRestricted;
    }

    render() {
        if (!this.props.topNav) {
            return null;
        }

        const {
            isPageOwner,
            topNav,
            selSection,
            isTrustedUser,
            showUGCTranslateBtn = false
        } = this.props;

        const { businessLayout } = this.context;

        const shouldRenderReportBtn = this.shouldRenderReportBtn();

        return (
            <div className="top-nav">
                <nav className="max-width-container">
                    <ul>
                        {
                            this.getValidatedSections().map((section, index) => {
                                const { sectionKey } = section;

                                return (
                                    <li key={index}
                                        className={classNames(`nav-${sectionKey}`, { 'selected': selSection === sectionKey })}>
                                        <a href={`#${sectionKey}`} onClick={(e) => this.onNavClick(e, section)}>
                                            <I18n k={`gig_page_perseus.top_nav.page_sections.${sectionKey}`}/>
                                        </a>
                                    </li>
                                );
                            })
                        }
                    </ul>
                    <aside className="actions">
                        {showUGCTranslateBtn && <UGCTranslateButton componentName={GIG_NAV_MENU} isLeanStyle/>}
                        {isPageOwner && <EditGig/>}
                        {!isPageOwner && !businessLayout && <CollectWrapper gigCollectedCount={topNav.gigCollectedCount}/>}
                        {shouldRenderReportBtn && <ReportBtn isTrustedUser={isTrustedUser}/>}
                        {!isPageOwner &&
                        <Tooltip content={<I18n k={'gig_page_perseus.top_nav.share_gig.tooltip'}/>}
                            className="sharing-link-tooltip"
                            containerClassName="sharing-link-tooltip-container"
                            boxContentClassName="sharing-link-tooltip-box">
                            <SocialSharing sellerName={topNav.sellerName}
                                isPageOwner={isPageOwner}/>
                        </Tooltip>
                        }
                    </aside>
                </nav>
            </div>
        );
    }
}

TopNav.propTypes = {
    topNav: shape({
        gigCollectedCount: number,
        sellerName: string
    }).isRequired,
    isPageOwner: bool,
    selSection: string,
    pageSectionsList: array,
    isTrustedUser: bool,
    showUGCTranslateBtn: bool
};

TopNav.contextTypes = {
    biEvents: object,
    currentUser: object,
    businessLayout: bool
};

export { TopNav };
export default SafePureComponent(TopNav);
